import React, { useEffect } from 'react';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import { GOOGLE_SCOPES } from 'common/variables';
import { AuthContext, useAuth, useProvideAuth } from 'common/auth';
import { GoogleLogin, googleLogout } from '@react-oauth/google';

export function ProvideAuth({ children }) {
  const token = localStorage.getItem('hijackToken');
  const user = localStorage.getItem('hijackUserObj');
  const parsedToken = token !== 'undefined' ? JSON.parse(token) : null;
  const parsedUser = token !== 'undefined' ? JSON.parse(user) : null;
  const auth = useProvideAuth({token: parsedToken, user: parsedUser});

  useEffect(() => {
    if (localStorage.getItem('hijackUser') !== 'true'){
      auth.performCheck();
    }
    if (localStorage.getItem('hijackToken') === 'undefined') {
      localStorage.setItem('hijackUser', 'false');
    }
  }, []);

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function LoginButton() {
  const history = useHistory(),
    location = useLocation(),
    auth = useAuth();

  const { from } = location.state || { from: { pathname: '/' } };
  const onSuccess = resp => auth.signIn(resp).then(() => history.replace(from));
  const onFailure = resp => console.error(resp);

  return <GoogleLogin
    text="signin_with"
    shape="rectangular"
    theme="filled_blue"
    onSuccess={onSuccess}
    onFailure={onFailure}
    scope={GOOGLE_SCOPES.join(' ')}
  />;
}

export function LogoutButton(props) {
  const auth = useAuth();
  const history = useHistory();

  const handleLogout = () => {
    googleLogout();
    auth.signOut().then(() => history.push('/'));
  };

  return (
    <button
      onClick={handleLogout}
      className={props.className}
    >
      Logout
    </button>
  );
}

export function PrivateRoute({ children, ...rest }) {
  const auth = useAuth();

  return (
    <Route
      {...rest}
      render={({location}) => auth.user ? (children) : (
        <Redirect to={{
          pathname: '/sign-in',
          state: { from: location },
        }}/>
      )}
    />
  );
}

export function CalendarPrivateRoute({ children, ...rest }) {
  const auth = useAuth();
  const user = auth.user;
  return (
    <Route
      {...rest}
      render={({location}) => user && user.enable_hebcal_calendar ? (children) : (
        <Redirect to={{
          pathname: '/',
          state: { from: location },
        }}/>
      )}
    />
  );
}